import * as React from "react";
import { useQuery } from "@grandvisionhq/graphql";
import { GET_PREFERRED_STORE_WITH_INVENTORY, GET_PREFERRED_STORE } from "../../../../operations/queries/operations/queries/get-preferred-store.js";
import { mapStoreResult } from "../../adapters/hooks/api/adapters/mapStoresResult.js";
const useGetPreferredStore = ({ onError, sku } = {}) => {
  const query = useQuery(
    sku ? GET_PREFERRED_STORE_WITH_INVENTORY : GET_PREFERRED_STORE,
    {
      variables: {
        sku
      },
      onError(error) {
        onError?.(error, "stores.storeDetailsRoot.preferredStoreFetch.error");
      }
    }
  );
  const data = React.useMemo(() => {
    if (query.data?.me?.preferredStore) {
      return mapStoreResult(query.data?.me?.preferredStore);
    }
    return null;
  }, [query]);
  return {
    data,
    loading: query.loading,
    error: query.error
  };
};
export {
  useGetPreferredStore as default
};
//# sourceMappingURL=use-get-preferred-store.js.map
